module.exports = __webpack_public_path__ + "static/media/mask-legend.d188cc1f.png";